/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumHinweis: {
    name: 'big-medium-hinweis';
    data: string;
} = {
    name: 'big-medium-hinweis',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M61 79h6a2 2 0 0 0 2-2l1-45a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2l1 45a2 2 0 0 0 2 2"/><path d="M64 3a61 61 0 1 0 61 61A61.06 61.06 0 0 0 64 3m0 112a51 51 0 1 1 51-51 51.06 51.06 0 0 1-51 51"/><circle cx="64" cy="92" r="6"/></svg>`,
};
